import { ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { SplashComponent } from './splash.component';

@NgModule({
  declarations: [
    SplashComponent    
  ],
  imports: [
    CommonModule,
    RouterModule
  ]
})

export class SplashModule {}



// WEBPACK FOOTER //
// C:/dev/um.stamps/src/app/splash/splash.module.ts